import React from 'react';
import { FeatureContainer } from './featureElements';

function Features() {
    return (
        <FeatureContainer>
            <h1>"The people who like to eat are always the best"</h1>
            <p>Julia Child</p>
        </FeatureContainer>
    )
}

export default Features
